<template>
  <div class="instagram mozzarella">
    <div class="instagram__container">
      <h2>{{ data.title }}</h2>
      <swiper
        v-if="isSmallScreen"
        class="instagram__swiper"
        :spaceBetween="spaceBetween"
        :slidesPerView="1"
        :pagination="{ clickable: true, el: '.swiper-pagination' }"
        :modules="modules"
      >
        <swiper-slide
          class="instagram__slide"
          v-for="(item, i) in data.slides"
          :key="i"
        >
          <div class="swiper__item">
            <div class="instagram__circle">
              <img
                :src="require(`../assets/icons/${item.img}`)"
                alt=""
                class="swiper__icon"
              />
            </div>
            <p>{{ item.content }}</p>
          </div>
        </swiper-slide>
        <div class="swiper-pagination"></div>
      </swiper>

      <div v-else class="instagram__flex">
        <div class="instagram__item" v-for="(item, i) in data.slides" :key="i">
          <div class="instagram__circle">
            <img
              :src="require(`../assets/icons/${item.img}`)"
              alt=""
              class="instagram__icon"
            />
          </div>
          <p>{{ item.content }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, onBeforeUnmount } from "vue";
import Content from "../data/content";
import { Swiper, SwiperSlide } from "swiper/vue";
import { Pagination } from "swiper/modules";
import "swiper/css";

export default {
  name: "InstaGram",

  components: {
    Swiper,
    SwiperSlide,
  },

  setup() {
    const lang = process.env.VUE_APP_LOCALITY;
    const data = ref(Content[lang].insta);
    const isSmallScreen = ref(window.innerWidth <= 922);
    const spaceBetween = ref(20);

    const updateScreenSize = () => {
      isSmallScreen.value = window.innerWidth <= 922;
    };

    onMounted(() => window.addEventListener("resize", updateScreenSize));

    onBeforeUnmount(() =>
      window.removeEventListener("resize", updateScreenSize)
    );

    return {
      data,
      isSmallScreen,
      spaceBetween,
      modules: [Pagination],
    };
  },
};
</script>

<style>
.instagram__container {
  padding: 58px 0px 76px;
  max-width: 1024px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}

.instagram__flex {
  display: flex;
  flex-wrap: wrap;
  gap: 22px;
  justify-content: space-around;
  margin: 20px;
}

.instagram h2 {
  text-align: center;
  margin: 0 auto 50px;
}

.instagram__item,
.swiper__item {
  flex: 1 1 calc(50% - 20px);
  border-radius: 16px;
  border: 1.5px #242e30;
  background: #ffffff;
  padding: 28px 41px;
  max-width: 488px;
  display: flex;
  flex-direction: row;
  align-items: center;
  overflow: hidden;
  gap: 22px;
  position: relative;
}

.instagram__item p,
.swiper__item p {
  color: #242e30;
  font-family: "JETSansDigital", sans-serif;
  font-size: 16px;
  line-height: 1.5;
  letter-spacing: -0.1px;
  margin: 0;
  flex: 1;
}

.instagram__circle {
  width: 71px;
  height: 71px;
  background: #fd7300;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
}

.instagram__icon,
.swiper__icon {
  width: 38px;
  height: 38px;
}

.swiper-pagination {
  display: flex;
  justify-content: center;
  gap: 15px;
  margin-top: 20px;
}
.swiper-pagination-bullet {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  border: 1px solid #242e30;
  transition: background-color 0.3s;
}

.swiper-pagination-bullet-active {
  background: #242e30;
}

@media only screen and (max-width: 768px) {
  .instagram__container {
    width: 100%;
    display: inline-block;
    padding: 18px 25px 26px;
    margin-top: 20px;
  }

  .instagram h2 {
    font-size: 30px;
    line-height: 36px;
    text-align: center;
  }

  .instagram__slide {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .instagram__circle {
    width: 44px;
    height: 44px;
  }

  .swiper__item {
    margin: 0 auto;
    gap: 13px;
  }

  .swiper__item p {
    font-size: 10px;
    line-height: 14px;
    letter-spacing: -0.12px;
    font-weight: 400;
  }

  .swiper__icon {
    width: 24px;
    height: 24px;
  }
}

@media only screen and (max-width: 992px) and (min-width: 768px) {
  .instagram__container {
    padding: 40px;
    display: inline-block;
    margin-top: 20px;
  }

  .instagram__slide {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
}
</style>
